import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const icon = props => (
    <SvgIcon {...props}>
        <path d="M5 25.7802V9.36565L17.9581 4L25 6.52406V28.6207L17.9581 31L5 25.7802L17.9581 27.5277V8.41954L9.50699 10.6293V23.5715L5 25.7802Z" fill="#EB3C00"/>
    </SvgIcon>
);

export default icon;